
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cbd-stores/[[...location]]",
      function () {
        return require("private-next-pages/cbd-stores/[[...location]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cbd-stores/[[...location]]"])
      });
    }
  